/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Table_PriceInputs */

const en_platform_table_price = /** @type {(inputs: Platform_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const zh_hans1_platform_table_price = /** @type {(inputs: Platform_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const pt_br2_platform_table_price = /** @type {(inputs: Platform_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const es_platform_table_price = /** @type {(inputs: Platform_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fr_platform_table_price = /** @type {(inputs: Platform_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const de_platform_table_price = /** @type {(inputs: Platform_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const ru_platform_table_price = /** @type {(inputs: Platform_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const it_platform_table_price = /** @type {(inputs: Platform_Table_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Platform_Table_PriceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_table_price = /** @type {((inputs?: Platform_Table_PriceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Table_PriceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_table_price(inputs)
	if (locale === "pt-BR") return pt_br2_platform_table_price(inputs)
	if (locale === "es") return es_platform_table_price(inputs)
	if (locale === "fr") return fr_platform_table_price(inputs)
	if (locale === "de") return de_platform_table_price(inputs)
	if (locale === "ru") return ru_platform_table_price(inputs)
	if (locale === "it") return it_platform_table_price(inputs)
	return en_platform_table_price(inputs)
});